
/* injects from baggage-loader */

'use strict';

import AccountChangePasswordController from './account.change-password.controller';
import AccountChangePasswordTemplate from './account.change-password.html';

export default class AccountChangePasswordComponent {
		constructor() {
				this.templateUrl = AccountChangePasswordTemplate;
				this.controller = AccountChangePasswordController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					user: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/change-password/account.change-password.component.js